export default class GlobalParametersDto {
    constructor(obj) {
        this.module = obj.module
        this.parameter = obj.parameter
        this.value = obj.value
        this.updateDate = obj.updateDate
        this.updateLogin = obj.updateLogin
    }
}